<template lang="html">
  <layout-public :practiceName="practiceName" class="sign-up">
    <div>
      <h4 class="snug">Patients</h4>
      <h1>Sign Up</h1>
      <input type="text" name="email" class="form-control" placeholder="Enter email" v-model="email" @keyup.enter="signUp">
      <input type="password" name="password" class="form-control" placeholder="Enter password" v-model="password" @keyup.enter="signUp">
      <label class="normal-weight form-check">
        <input type="checkbox" name="termsAccepted" v-model="termsAccepted" value="termsAccepted" class="form-check-input">
        <small>I accept the <a href="https://healthassuranceplan.com/terms-of-service/" target="_blank">terms of service</a></small>.
      </label>

      <list-errors :errors="errors"></list-errors>

      <p v-if="practiceAccountId && !loading"><button class="btn btn-app"  @click="signUp">Sign Up<i class="far fa-angle-right fa-fw fa-right"></i></button></p>

      <p v-if="loading"><i class="far fa-fw fa-pulse fa-spinner"></i></p>

      <hr class="hr-form-footer" />

      <p>Already signed up? <router-link :to="{path: '/log-in', query: { redirect: this.$route.query.redirect } }">Log in</router-link>.</p>
    </div>
  </layout-public>
</template>

<script>
import Vue from 'vue'
import {mapGetters} from 'vuex'
import LayoutPublic from '../components/LayoutPublic.vue'
import ListErrors from '../components/ListErrors.vue'

export default {
  props: [''],
  data () {
    return {
      email: '',
      password: '',
      errors: [],
      termsAccepted: false,
      pageUrl: null,
      salesMeta: null,
      practiceAccountId: null,
      practiceName: null,
      loading: false,
    }
  },
  components: {
    LayoutPublic, ListErrors
  },
  computed: {
    ...mapGetters(['user']),
    // get next route from querystring, set in FirebaseApp.js, or default
    nextRoute () {
      return this.$route.query.redirect || '/agreement'
    },
  },
  watch: {
    // load the page when the pageUrl is set from params
    pageUrl () {
      if (this.pageUrl) {
        let metaRef = Vue.db.ref(`/sales_page_meta/`)
          .orderByChild('salesURL')
          .equalTo(this.pageUrl)
      	  .on('value', (metaSnapshot) => {
            this.loading = false;
            // get first index in values array since orderByChild returns an object of objects
            if(metaSnapshot.val()) {
              this.salesMeta = Object.values(metaSnapshot.val())[0];
              this.practiceAccountId = this.salesMeta.practice_account_id;
              this.practiceName = this.salesMeta.practiceName;
              this.$store.dispatch('setGuarantorPracticeName', this.salesMeta.practiceName);
              this.$store.dispatch('setGuarantorPracticeUrl', this.pageUrl);
            } else {
              this.$router.push({ name: '404' })
            }
          });
      }
    },
    //  when signUp completes, go to requested page
    user (auth) {
      if(auth) {
        this.$router.replace(this.nextRoute)
      }
    }
  },
  methods: {
    async signUp () {
      this.loading = true;
      // reset errors
      this.errors = [];
      // if privacy policy not accepted, show error
      if(!this.termsAccepted) {
        this.errors.push("You must accept the terms of service and privacy policy.")
        this.loading = false;
        return;
      }
      // if no practice account id, show error
      if(!this.practiceAccountId) {
        this.errors.push("No practice account found, please reload the page and try again.")
        this.loading = false;
        return;
      }
      //  attempt signUp
      let result = await this.$firebase.signUpGuarantor(this.email, this.password, this.practiceAccountId)
      // if result doesn't contain user, it's an error
      // console.log(result);
      if(result && result.code) {
        this.loading = false;
        if(result.code == "auth/invalid-email") {
          this.errors.push("Oops, that's not a valid email address.")
        }
        else if(result.code == "auth/weak-password") {
          this.errors.push("Oops, your password must be at least 6 characters.")
        }
        else {
          this.errors.push(result.message);
        }
      }
      // if no errors, send email verification
      else {
        this.$firebase.verifyEmail()
          .then(() => {
            this.$router.replace(this.nextRoute)
          })
          .catch(err => console.log(err));
      }

    },
  },
  created () {
    if(this.$route.params.id) {
      this.pageUrl = this.$route.params.id
    }
    if(this.user && this.$route.path !== this.nextRoute) {
      this.$router.replace(this.nextRoute)
    }
  },
  mounted () {
    if(this.user && this.$route.path !== this.nextRoute) {
      this.$router.replace(this.nextRoute)
    }
  },
}
</script>

<style lang="less" scoped>
@import "../assets/less/variables.less";

.layout-public .container:before {
  // background: url('../assets/img/ha-splash-faces.png') center right no-repeat;
  background: none;
}

.form-check {
  margin-bottom: 30px;
}
hr.hr-form-footer {
  margin-bottom: 30px;
}

</style>
